import { action } from 'typesafe-actions';
import { CoreActionTypes, VisaStatus } from './types';

export const updateVisaStatus = (status: VisaStatus) => action(CoreActionTypes.UPDATE_VISA_STATUS, status);

export const createUpdateOfferFieldAction = (fieldName: string, value: any, refValue?: any) =>
  action(CoreActionTypes.UPDATE_OFFER_FIELD, {
    fieldName,
    value,
    refValue
  });
